import { autorun, makeAutoObservable, runInAction } from 'mobx';
import {
  getProjectIteration,
  startIterationProduction,
  startProcessIteration,
  stopProcessIteration,
  forceCompleteIteration,
} from '../../services/projects.services';
import { SchemeNodeTypes, StatusIteration } from 'consts/scheme.consts';

const NAME = 'production-store';
export class ProductionStore {
  selectedProduction = null;
  selectedProductionId = null;
  selectedProductionData = null;
  listIteration = [];
  isLoading = false;
  latestStartedProcessId = null;

  constructor() {
    makeAutoObservable(this);

    const storeJSON = localStorage.getItem(NAME);

    if (storeJSON) Object.assign(this, JSON.parse(storeJSON));

    autorun(() => {
      const obj = JSON.parse(JSON.stringify(this));
      const current = localStorage.getItem(NAME);
      const newVal = JSON.stringify(obj);
      if (current !== newVal) {
        localStorage.setItem(NAME, newVal);
      }
    });

    window.addEventListener('storage', this._updateStore);
    window.addEventListener('beforeunload', this._dispose);
  }

  _updateStore = (e) => {
    if (e.key === NAME) {
      const storeJSON = localStorage.getItem(NAME);

      if (storeJSON) Object.assign(this, JSON.parse(storeJSON));
    }
  };

  _dispose = () => {
    window.removeEventListener('storage', this._updateStore);
  };

  _updateIteration(updated) {
    this.listIteration = this.listIteration.map((item) =>
      item.id === updated.id ? updated : item,
    );
  }

  _handleListIteration = (array) => {
    const result = [];
    function traverse(nodes) {
      nodes.forEach((node) => {
        if (node.type !== SchemeNodeTypes.qualityControl) {
          if (
            node.status === StatusIteration.NotStarted ||
            node.status === StatusIteration.InProgress
          ) {
            result.push(node);
            const qualityNode = node?.children?.find(
              (item) =>
                item.type === SchemeNodeTypes.qualityControl &&
                item.status !== StatusIteration.Completed,
            );
            if (qualityNode) {
              result.push(qualityNode);
            }
          } else if (node.children && Array.isArray(node.children)) {
            const qualityNode = node?.children?.find(
              (item) =>
                item.type === SchemeNodeTypes.qualityControl &&
                item.status !== StatusIteration.Completed,
            );
            if (qualityNode) {
              result.push(qualityNode);
            }
            traverse(node.children);
          }
        }
      });
    }

    traverse(array);

    return result;
  };

  _updateSelectedProductionData = async () => {
    const res = await getProjectIteration(this.selectedProductionData.id);

    if (res.success) {
      this.selectedProductionData = res.result.data;
    }
  };

  setSelectProduction = async (id) => {
    runInAction(() => {
      this.isLoading = true;
    });
    if (id === null) {
      runInAction(() => {
        this.selectedProductionId = null;
        this.selectedProduction = null;
        this.selectedProductionData = null;
        this.listIteration = [];
      });
    }

    const response = await getProjectIteration(id);

    if (response.success) {
      runInAction(() => {
        this.selectedProductionId = id;
        this.selectedProduction = response.result.data?.process_scheme?.nodes;
        this.selectedProductionData = response.result.data;
        this.listIteration = this._handleListIteration(response.result.data?.process_scheme?.nodes);
      });
    }

    runInAction(() => {
      this.isLoading = false;
    });
  };

  startIteration = async () => {
    try {
      const response = await startIterationProduction(this.selectedProductionId);
      if (response.success) {
        runInAction(() => {
          this.selectedProduction = response.result.data?.process_scheme?.nodes;
          this.selectedProductionData = response.result.data;
          this.listIteration = this._handleListIteration(
            response.result.data?.process_scheme?.nodes,
          );
        });
        return { status: response.success };
      } else {
        return {
          status: response.success,
          message: response.error,
          errorCode: response.error_code,
        };
      }
    } catch (err) {
      const error = err.response.data;
      return {
        status: error.success,
        message: error.error,
        errorCode: error.error_code,
      };
    }
  };

  startProcessIteration = async (id, data) => {
    try {
      const response = await startProcessIteration(id, data);

      if (response.success) {
        runInAction(() => {
          this.selectedProduction = response.result.data;
          this.listIteration = this._handleListIteration(response.result.data);
          this.latestStartedProcessId = id;
        });
        return { status: response.success };
      } else {
        return {
          status: response.success,
          message: response.error,
        };
      }
    } catch (err) {
      const error = err.response.data;
      return {
        status: error.success,
        message: error.error,
      };
    }
  };

  stopProcessIteration = async (node, data) => {
    const response = await stopProcessIteration(node.id, data);

    if (response.success) {
      runInAction(async () => {
        this.selectedProduction = response.result.data;
        this.listIteration = this._handleListIteration(response.result.data);
        await this._updateSelectedProductionData();
      });
      return { status: response.success };
    } else {
      return {
        status: response.success,
        message: response.error,
      };
    }
  };

  setLatestStartedProcessId = (id) => {
    runInAction(() => (this.latestStartedProcessId = id));
  };

  forceCompleteIteration = async (id_iteration, data) => {
    const response = await forceCompleteIteration(id_iteration, data);

    if (response.success) {
      runInAction(() => {
        this.selectedProductionData = response.result.data;
      });
      return { status: response.success };
    } else {
      return {
        status: response.success,
        message: response.error,
        code: response.error_code,
      };
    }
  };

  reset = () => {
    runInAction(() => {
      this.selectedProduction = null;
      this.selectedProductionId = null;
      this.selectedProductionData = null;
      this.listIteration = [];
      this.isLoading = false;
      this.latestStartedProcessId = null;
    });
  };
}

export const productionStore = new ProductionStore();
